import {
	ClickAwayListener,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
} from '@mui/material'
import { Popup } from 'react-map-gl/mapbox'

import { formatDemographics } from './functions'

import type { HoneygridAPIH3CellProperties } from 'honeygrid-types'
import type { FC } from 'react'

const CellDetailsMarker: FC<{
	cell: HoneygridAPIH3CellProperties | null
	onClose: () => void
}> = ({ cell, onClose }) => {
	if (!cell) {
		return null
	}

	const { homeValuesUSD, households, marketShare, sales, customerCount, newMovers } =
		formatDemographics(cell)

	return (
		<Popup
			latitude={cell.center[0]}
			longitude={cell.center[1]}
			closeOnClick={false}
			closeButton={false}
		>
			<ClickAwayListener onClickAway={onClose}>
				<TableContainer component={Paper}>
					<Table>
						<TableBody>
							{marketShare ? (
								<TableRow>
									<TableCell>Market Share</TableCell>
									<TableCell>{marketShare}</TableCell>
								</TableRow>
							) : null}
							{sales ? (
								<TableRow>
									<TableCell>Sales</TableCell>
									<TableCell>{sales}</TableCell>
								</TableRow>
							) : null}
							{customerCount ? (
								<TableRow>
									<TableCell>Customer Count</TableCell>
									<TableCell>{customerCount}</TableCell>
								</TableRow>
							) : null}
							{homeValuesUSD ? (
								<TableRow>
									<TableCell>Home Values</TableCell>
									<TableCell>{homeValuesUSD}</TableCell>
								</TableRow>
							) : null}
							{households ? (
								<TableRow>
									<TableCell>Households</TableCell>
									<TableCell>{households}</TableCell>
								</TableRow>
							) : null}
							{newMovers ? (
								<TableRow>
									<TableCell>New Movers</TableCell>
									<TableCell>{newMovers}</TableCell>
								</TableRow>
							) : null}
						</TableBody>
					</Table>
				</TableContainer>
			</ClickAwayListener>
		</Popup>
	)
}

export { CellDetailsMarker }
